// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInExistingAccountStyles } from "@rpsc/Overrides/Widgets/SignIn/SignInExistingAccount";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

signInExistingAccountStyles.signInExistingAccountTitle = {
    css: css`
        margin-bottom: 16px;
    `,
};

signInExistingAccountStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

signInExistingAccountStyles.signInGridContainer = {
    gap: 12,
};

signInExistingAccountStyles.signInButtonGridItem = {
    width: 12,
    css: css`
        &&& {
            margin-top: 4px;
        }
    `,
};

signInExistingAccountStyles.forgotPasswordLink = {
    typographyProps: {
        size: 12,
        lineHeight: "17px",
        weight: fontConfig.weight.bold,
    },
};
signInExistingAccountStyles.resetPasswordModal = {
    sizeVariant: "small",
    cssOverrides: {
        modalBody: css`
            ${xScreen("lte", "md")} {
                max-width: 70%;
                height: auto;
                max-height: calc(100% - 30px);
                margin: 15px;
                input {
                    max-width: 100%;
                }
            }
            ${xScreen("lte", "sm")} {
                max-width: 90%;
            }
        `,
    },
};
